import { filtersConfig, OptionType } from "@src/utils/reactSelectUtils";
import { Control, FieldValues, Path, useController } from "react-hook-form";
import Select from "react-select";

interface SelectYupProps<T extends FieldValues> {
	control: Control<T>;
	name: Path<T>;
	options: Array<OptionType>;
	placeholder?: string;
	isLoading?: boolean;
	isDisabled?: boolean;
}

export const SelectYup = <T extends FieldValues>({
	control,
	name,
	options,
	placeholder,
	isLoading,
	isDisabled,
}: SelectYupProps<T>) => {
	const { field, fieldState } = useController({ name, control });
	const fieldValue = field?.value;
	const selectedOption =
		options.find((option) => option.value === fieldValue) ??
		(fieldValue ? { label: String(fieldValue), value: fieldValue } : null);

	const { isDirty, invalid } = fieldState;

	const innerTernary = field.value && isDirty ? "success" : "none";
	const inputStatus = invalid ? "error" : innerTernary;
	const customStyles = filtersConfig(inputStatus, "m");

	return (
		<Select
			isClearable
			isDisabled={isDisabled ?? false}
			isLoading={isLoading ?? false}
			options={options}
			placeholder={placeholder}
			onChange={(data) => {
				field.onChange(data?.value ?? "");
			}}
			value={selectedOption}
			isMulti={false}
			styles={customStyles}
			components={{ IndicatorSeparator: null }}
		/>
	);
};
